import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(
  theme => ({
    icon: {
      color: '#0097EC'
    },
    root: {
      width: '100%'
    }
  }),
  { classNamePrefix: 'Accordion' }
)
